@if (isLoading && !downloadBillClicked) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-title>Chargement de vos factures</mat-card-title>
      @if (isLoading) {
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      }
    </mat-card>
  </div>
}

@if (!downloadBillClicked) {
  <div >
    @if (!isLoading && showBanner && canUseMandat(null)) {
      <div class="mat-card banner">
        <span>{{bodyBanner}}</span> <a [routerLink]="'/mandat/sign'">abonnez-vous au prélèvement automatisé</a>
        <span class="material-icons md-12 click_button btn-close" (click)="closeBanner()">close</span>
      </div>
    }
    @for (billsPerEj of billsPerEjList; track billsPerEj) {
      <div>
        <mat-card appearance="outlined">
          <mat-card-title>Factures {{ billsPerEj.ejLibelle }}</mat-card-title>
          <mat-card-content>
            <table mat-table [dataSource]="billsPerEj.factures" class="mat-elevation-z0">
              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef></th>
                <td *matCellDef="let element" mat-cell><span
                class="left">{{element.itemDateIssue | date:'dd/MM/yy' }}</span><br/><span
              class="item_number">{{element.itemNumber}}</span></td>
              <td mat-footer-cell *matFooterCellDef> Montant total </td>
            </ng-container>
            <ng-container matColumnDef="itemDateDueTrans">
              <th mat-header-cell *matHeaderCellDef> Echéance </th>
              <td *matCellDef="let element" class="center" mat-cell> {{element.itemDateDueTrans | date:'dd/MM/yy' }} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef> Montant </th>
              <td class="center" mat-cell *matCellDef="let element"> {{element.itemAmountRemainingIncTax | number:'1.2':'fr-FR' }}€ </td>
              <td class="center" mat-footer-cell *matFooterCellDef> {{ totalAmountCalculator(billsPerEj.factures) | number:'1.2':'fr-FR' }}€ </td>
            </ng-container>
            <ng-container matColumnDef="bill">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                @if (isValidDateForPdf(element) && (element.naturePiece.startsWith('FC') || element.naturePiece.startsWith('AC')) && (element.migration || (!element.migration && element.token!==null))) {
                  <div  class="center click_button icon-bill"
                    (click)="openBill(element, billsPerEj.ej)">
                    <mat-icon>picture_as_pdf</mat-icon>
                  </div>
                }
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="payment">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                @if (displayPaymentCard(element)) {
                  <div class="center click_button icon-bill"
                    (click)="openPaymentLink(element.paymentLink)">
                    <mat-icon>payment</mat-icon>
                  </div>
                }
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
          </table>
        </mat-card-content>
        @if (canUseMandat(billsPerEj.ej) && totalAmountCalculator(billsPerEj.factures)>0 && !hasPrl(billsPerEj)) {
          <mat-card-footer
            >
            <button (click)="redirectToMandat(billsPerEj)" class="btn-mandat" mat-raised-button>M'abonner au prélèvement
            </button>
          </mat-card-footer>
        }
      </mat-card>
    </div>
  }
</div>
}

@if (isLoading && downloadBillClicked) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-title>Téléchargement de votre facture en cours</mat-card-title>
      @if (isLoading) {
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      }
    </mat-card>
  </div>
}

@if (showNoBills) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-title>Factures</mat-card-title>
      <mat-card-content>Aucune facture n'a été trouvée.</mat-card-content>
    </mat-card>
  </div>
}
